import { Close } from "@mui/icons-material";
import { IconButton, TextField } from "@mui/material";
import type React from "react";
import { useMemo } from "react";

import type { AttributeInputProps } from "./types.ts";
import "./attribute-filter.css"

export const NajetoDo: React.FC<AttributeInputProps> = ({
  overviewForm,
  attributesList,
}) => {
  const attribute = useMemo(()=>attributesList.find((attr) => attr.name === "NajeteKilometry"),[attributesList]);

  if (!attribute) {
    return null;
  }

  return (
    <overviewForm.Field name="DetailCategoryFilter.NajetoDo">
      {(fieldApi) => {

        const EMPTY_VALUE = ''

        const value = fieldApi.state.value;
        const displayValue = (
          value === undefined || value === null || value === ''?
            EMPTY_VALUE
            : Intl.NumberFormat("cs-CZ", {maximumFractionDigits: 0}).format(value)
        );

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const inputValue = e.target.value.trim();

          // Remove all non-numeric characters except decimal separators
          const cleanedValue = inputValue.replace(/[^\d.,]/g, "");

          // Parse the cleaned value (handle both comma and dot as decimal separator)
          const parsedValue = cleanedValue.replace(/,/g, ".");
          if (inputValue === '') {
            fieldApi.setValue(null); // Convert to integer for price
          } else {
            const numberValue = Number(parsedValue);

            // Only update if it's a valid number
            if (!Number.isNaN(numberValue)) {
              fieldApi.setValue(Math.floor(numberValue)); // Convert to integer for price
            }
          }
        };

        return (
          <TextField
            className="SzTextInput-Numeric"
            label="Najeto do (km)"
            fullWidth={true}
            color="secondary"
            size="small"
            variant="filled"
            // inputMode="numeric"
            value={displayValue}
            onChange={handleChange}
            slotProps={{
              input: {
                endAdornment:
                  displayValue !== EMPTY_VALUE ? (
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => {
                        fieldApi.setValue("");
                      }}
                    >
                      <Close/>
                    </IconButton>
                  ) : null,
              },
            }}
          />
        );
      }}
    </overviewForm.Field>
  );
};
